import {React,useEffect,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import './TrackingSystem.css';
import systemImage from '../../assets/images/MacStudio.png';
import shopifyLogo from '../../assets/icons/shopify.svg';

const TrackingSystem = () => {
 const sectionRef = useRef();
   const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
      <div className="tracking-system" ref={sectionRef} id="products">
           <div className="tracking-system__container">
             <div className="tracking-system__image-container">
               <img 
                 src={systemImage} 
                 alt="Profit Pulse App" 
                 className="tracking-system__image"
                 loading="lazy"
               />
               <div className="tracking-system__image-glow"></div>
             </div>
             
             <div className="tracking-system__content">
               <span className="tracking-system__badge">Shopify Accounting System</span>
               <h2 className="tracking-system__title">
               Supercharge Your Growth with the
                 <span className="tracking-system__title-highlight"> Ultimate </span>Shopify Powerhouse
               </h2>
               <p className="tracking-system__description">
               Unlock Real-Time Insights & Total Control of Your Shopify Finances
               </p>
               
               <div className="tracking-system__features">
                 <div className="tracking-system__feature">
                   <div className="tracking-system__feature-icon">
                   🧾
                    </div>
                   <div>
                     <h3 className="tracking-system__feature-title">Statement of Account</h3>
                     <p className="tracking-system__feature-text">Generate detailed transaction logs, including credits, debits, and balances. Export statements as PDFs for record-keeping and financial analysis.</p>
                   </div>
                 </div>
                 
                 <div className="tracking-system__feature">
                   <div className="tracking-system__feature-icon">📈
                </div>
                   <div>
                     <h3 className="tracking-system__feature-title">Sales Analytics</h3>
                     <p className="tracking-system__feature-text">Dynamic charts for sales performance.</p>
                   </div>
                 </div>
                 
                 <div className="tracking-system__feature">
                   <div className="tracking-system__feature-icon"> 💵</div>
                   <div>
                     <h3 className="tracking-system__feature-title">Invoice Generation</h3>
                     <p className="tracking-system__feature-text">Quickly generate professional invoices, streamline your billing process, and get paid faster with ease.</p>
                   </div>
                 </div>
               </div>
               <button className="bdesign__cta"  onClick={() => window.open('/shopify-accounting-system', '_blank', 'noopener,noreferrer')}>
            Discover Full Features
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.25 5L16.25 10L11.25 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3.75 10H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
             </div>
           </div>
         </div>
      );
    };

export default TrackingSystem;
